// extracted by mini-css-extract-plugin
module.exports = {"CountryModal":"styles_CountryModal__Nmnnr","footerMessage":"styles_footerMessage__VjejX","linksWrapper":"styles_linksWrapper__eEPVY","link":"styles_link__q7uiH"};